import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=56b246cb&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=ts&"
export * from "./Maintenance.vue?vue&type=script&lang=ts&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=56b246cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b246cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
